"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachBody = void 0;
var utils_1 = require("../../utils/utils");
var listener_1 = require("../../utils/event-listener/listener");
var set_styles_1 = require("../../utils/set-styles");
var element_from_string_1 = require("../../utils/element-from-string");
var get_element_size_1 = require("../../utils/get-element-size");
var get_element_offset_1 = require("../../utils/get-element-offset");
var is_nil_1 = require("../../utils/is-nil");
var AttachBody = function (target) {
    return /** @class */ (function (_super) {
        __extends(AttachBody, _super);
        function AttachBody() {
            var constructorArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                constructorArgs[_i] = arguments[_i];
            }
            var _this = _super.apply(this, constructorArgs) || this;
            _this.positioningListeners = [];
            _this.dropdownParent = _this.options.get('dropdownParent') || document.body;
            return _this;
        }
        AttachBody.prototype.binding = function (select, container) {
            var _this = this;
            _super.prototype.binding.call(this, select, container);
            select.on('open', function () {
                _this._showDropdown();
                _this._attachPositioningHandler(select);
                // Must bind after the results handlers to ensure correct sizing
                _this._bindContainerResultHandlers(select);
            });
            select.on('close', function () {
                _this._hideDropdown();
                _this._detachPositioningHandler(select);
            });
            listener_1.createListener({
                elements: this.dropdownContainer,
                events: 'mousedown',
                listeners: this.core.listeners,
                callback: function (event) {
                    event.stopPropagation();
                }
            });
        };
        AttachBody.prototype.destroy = function () {
            listener_1.destroyListener(this.positioningListeners);
            _super.prototype.destroy.call(this);
            this.dropdownContainer.remove();
        };
        AttachBody.prototype.position = function (dropdown, container) {
            // Clone all of the container classes
            dropdown.classList.value = container.classList.value;
            dropdown.classList.remove('select2');
            dropdown.classList.add('select2-container--open');
            set_styles_1.setStyles(dropdown, {
                position: 'absolute',
                top: -999999
            });
            this.container = container;
        };
        AttachBody.prototype.render = function () {
            this.dropdownContainer = element_from_string_1.elementFromString('<span></span>');
            var dropdown = _super.prototype.render.call(this);
            this.dropdownContainer.append(dropdown);
            return this.dropdownContainer;
        };
        AttachBody.prototype._hideDropdown = function () {
            utils_1.Utils.detach(this.dropdownContainer);
        };
        AttachBody.prototype._bindContainerResultHandlers = function (select) {
            var _this = this;
            // These should only be bound once
            if (this.containerResultsHandlersBound) {
                return;
            }
            select.on('results:all', function () {
                _this._positionDropdown();
                _this._resizeDropdown();
            });
            select.on('results:append', function () {
                _this._positionDropdown();
                _this._resizeDropdown();
            });
            select.on('results:message', function () {
                _this._positionDropdown();
                _this._resizeDropdown();
            });
            select.on('select', function () {
                _this._positionDropdown();
                _this._resizeDropdown();
            });
            select.on('unselect', function () {
                _this._positionDropdown();
                _this._resizeDropdown();
            });
            this.containerResultsHandlersBound = true;
        };
        AttachBody.prototype._attachPositioningHandler = function (select) {
            var _this = this;
            var scrollEvent = 'scroll'; // 'scroll.select2.' + select.id;
            var resizeEvent = 'resize'; // 'resize.select2.' + select.id;
            var orientationEvent = 'orientationchange.select2.' + select.id;
            var watchers = utils_1.Utils.geElementParents(this.container).filter(utils_1.Utils.hasScroll);
            watchers.forEach(function (el) {
                utils_1.Utils.StoreData(el, 'select2-scroll-position', {
                    x: el.scrollLeft,
                    y: el.scrollTop
                });
                listener_1.createListener({
                    elements: el,
                    events: scrollEvent,
                    listeners: _this.positioningListeners,
                    callback: function () {
                        var position = utils_1.Utils.GetData(el, 'select2-scroll-position');
                        el.scrollTop = position.y;
                    }
                });
            });
            listener_1.createListener({
                elements: window,
                events: [scrollEvent, resizeEvent, orientationEvent].join(' '),
                listeners: this.positioningListeners,
                callback: function () {
                    _this._positionDropdown();
                    _this._resizeDropdown();
                }
            });
        };
        AttachBody.prototype._detachPositioningHandler = function (select) {
            listener_1.destroyListener(this.positioningListeners);
        };
        AttachBody.prototype._positionDropdown = function () {
            var isCurrentlyAbove = this.dropdown.classList.contains('select2-dropdown--above');
            var isCurrentlyBelow = this.dropdown.classList.contains('select2-dropdown--below');
            var newDirection = null;
            var offset = get_element_offset_1.getElementOffset(this.container);
            offset.bottom = offset.top + get_element_size_1.getElementOuterHeight(this.container);
            var container = {
                height: get_element_size_1.getElementOuterHeight(this.container)
            };
            container.top = offset.top;
            container.bottom = offset.top + container.height;
            var dropdown = {
                height: get_element_size_1.getElementOuterHeight(this.dropdown)
            };
            var viewport = {
                top: window.scrollY,
                bottom: window.scrollY + window.innerHeight
            };
            var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
            var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);
            var css = {
                left: offset.left,
                top: container.bottom
            };
            // Determine what the parent element is to use for calculating the offset
            var offsetParent = this.dropdownParent;
            // For statically positioned elements, we need to get the element
            // that is determining the offset
            if (offsetParent.style.position === 'static') {
                offsetParent = offsetParent.offsetParent;
            }
            var parentOffset = {
                top: 0,
                left: 0
            };
            if (document.body.contains(offsetParent) || offsetParent.isConnected) {
                parentOffset = get_element_offset_1.getElementOffset(offsetParent);
            }
            css.top -= parentOffset.top;
            css.left -= parentOffset.left;
            if (!isCurrentlyAbove && !isCurrentlyBelow) {
                newDirection = 'below';
            }
            if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
                newDirection = 'above';
            }
            else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
                newDirection = 'below';
            }
            if (newDirection === 'above' ||
                (isCurrentlyAbove && newDirection !== 'below')) {
                css.top = container.top - parentOffset.top - dropdown.height;
            }
            if (!is_nil_1.isNil(newDirection)) {
                this.dropdown.classList.remove('select2-dropdown--below');
                this.dropdown.classList.remove('select2-dropdown--above');
                this.dropdown.classList.add('select2-dropdown--' + newDirection);
                this.container.classList.remove('select2-container--below');
                this.container.classList.remove('select2-container--above');
                this.container.classList.add('select2-container--' + newDirection);
            }
            set_styles_1.setStyles(this.dropdownContainer, css);
        };
        AttachBody.prototype._resizeDropdown = function () {
            var css = {
                width: get_element_size_1.getElementOuterWidth(this.container) + 'px'
            };
            if (this.options.get('dropdownAutoWidth')) {
                css.minWidth = css.width;
                css.position = 'relative';
                css.width = 'auto';
            }
            set_styles_1.setStyles(this.dropdown, css);
        };
        AttachBody.prototype._showDropdown = function () {
            this.dropdownParent.append(this.dropdownContainer);
            this._positionDropdown();
            this._resizeDropdown();
        };
        return AttachBody;
    }(target));
};
exports.AttachBody = AttachBody;
//# sourceMappingURL=attach-body.js.map